import Pusher from "pusher-js";
import Echo from "laravel-echo";
import { AuthService } from "@/services";

const PUSHER = Pusher;
const ECHO = new Echo({
  broadcaster: "pusher",
  key: "a8d47f83958a7bbea359",
  wsHost: process.env.VUE_APP_BASE_URL_SOCKET,
  wsPort: +process.env.VUE_APP_BASE_URL_SOCKET_PORT,
  forceTLS: !!+process.env.VUE_APP_BASE_URL_SOCKET_USE_TLS,
  disableStats: false,
  cluster: "eu",
  authEndpoint: process.env.VUE_APP_BASE_URL_V4 + "/core/broadcasting/auth",
  auth: {
    headers: {
      Authorization: "Bearer " + AuthService.getAccessToken()
    }
  }
});
export default {
  PUSHER,
  ECHO
};
